// TopLosersView.js
import React, { useState } from 'react';
import TradingViewChartIcon from './TradingViewChartIcon';
import './TopGainersView.css'; // Reuse the same CSS
import { ensureArray } from './config';

const TopLosersView = ({ data }) => {
  const safeData = ensureArray(data);
  const timeFrames = [...new Set(safeData.map(d => d.timeFrame))].sort((a, b) => a - b);

  return (
    <div className="gainers-view-container">
      {timeFrames.map(tf => (
        <TimeFrameSection key={tf} timeFrame={tf} data={safeData.filter(d => d.timeFrame === tf)} />
      ))}
    </div>
  );
};

const TimeFrameSection = ({ timeFrame, data }) => {
  const safeData = ensureArray(data);
  const [filters, setFilters] = useState({ symbol: '' });
  const [sortConfig, setSortConfig] = useState({ key: 'change', direction: 'asc' }); // Ascending shows biggest loss first
  const [expanded, setExpanded] = useState(false);

  const symbols = [...new Set(safeData.map(d => d.symbol))];

  const filtered = safeData
    .filter(item => !filters.symbol || item.symbol === filters.symbol)
    .filter(item => parseFloat(item.change?.replace('%', '') || 0) < 0); // Only losers

  const sorted = [...filtered].sort((a, b) => {
    const { key, direction } = sortConfig;

    let valA = a[key];
    let valB = b[key];

    if (['change', 'adx', 'volumeChange'].includes(key)) {
      valA = parseFloat(valA) || 0;
      valB = parseFloat(valB) || 0;
    }

    if (valA < valB) return direction === 'asc' ? -1 : 1;
    if (valA > valB) return direction === 'asc' ? 1 : -1;
    return 0;
  });

  const displayData = expanded ? sorted : sorted.slice(0, 5);

  const handleSort = (key) => {
    setSortConfig(prev =>
      prev.key === key
        ? { key, direction: prev.direction === 'asc' ? 'desc' : 'asc' }
        : { key, direction: 'asc' }
    );
  };

  return (
    <div className="tf-section">
      <h3>Top Losers – {timeFrame} min</h3>
      <div className="filters">
        <select value={filters.symbol} onChange={e => setFilters({ ...filters, symbol: e.target.value })}>
          <option value="">Symbol</option>
          {symbols.map(s => <option key={s} value={s}>{s}</option>)}
        </select>
        {filtered.length > 5 && (
          <button className="expand-button" onClick={() => setExpanded(!expanded)}>
            {expanded ? 'Collapse' : 'Expand'}
          </button>
        )}
        <button onClick={() => setFilters({ symbol: '' })}>Clear Filters</button>
      </div>

      <div className="gainers-table-wrapper">
        <table className="gainers-table">
          <thead>
            <tr>
              <th>#</th>
              <th onClick={() => handleSort('symbol')}>Symbol {sortConfig.key === 'symbol' ? (sortConfig.direction === 'asc' ? '↑' : '↓') : '⬍'}</th>
              <th>Chart</th> 
              <th onClick={() => handleSort('marketPrice')}>Market Price {sortConfig.key === 'marketPrice' ? (sortConfig.direction === 'asc' ? '↑' : '↓') : '⬍'}</th>
              <th onClick={() => handleSort('change')}>Change % {sortConfig.key === 'change' ? (sortConfig.direction === 'asc' ? '↑' : '↓') : '⬍'}</th>
              <th onClick={() => handleSort('volumeChange')}>Vol Ch% {sortConfig.key === 'volumeChange' ? (sortConfig.direction === 'asc' ? '↑' : '↓') : '⬍'}</th>
              <th onClick={() => handleSort('volumeRank')}>VolumeRank {sortConfig.key === 'volumeRank' ? (sortConfig.direction === 'asc' ? '↑' : '↓') : '⬍'}</th>
              <th onClick={() => handleSort('adx')}>ADX {sortConfig.key === 'adx' ? (sortConfig.direction === 'asc' ? '↑' : '↓') : '⬍'}</th>
            </tr>
          </thead>
          <tbody>
            {displayData.map((item, idx) => {
                const changeVal = parseFloat(item.change);
                const rowClass = changeVal < -3 ? 'blink-red' : '';

                return (
                <tr key={idx} className={rowClass}>
                    <td>{idx + 1}</td>
                    <td>{item.symbol}</td>
                    <td>
                      <TradingViewChartIcon
                        symbol={item.symbol}
                        timeFrame={item.timeFrame}
                        exchange={item.exchange}
                      />
                    </td>                     
                    <td>{item.marketPrice}</td>
                    <td>{item.change}%</td>
                    <td>{item.volumeChange}</td>
                    <td>{item.volumeRank}</td>
                    <td>{item.adx}</td>
                </tr>
                );
            })}
            </tbody>

        </table>
      </div>
    </div>
  );
};

export default TopLosersView;
